import { isProduction } from 'utils/env'

export const LANGUAGE_COOKIE_NAME = 'lang'
export const CURRENCY_COOKIE_NAME = 'currency'
export const COUNTRY_COOKIE_NAME = 'cf-country'
export const REGION_COOKIE_NAME = 'cf-region'
export const SUBSCRIPTION_STATUS_COOKIE_NAME = 'cfsub_status'
export const STUDIO_AI_SUBSCRIPTION_STATUS_COOKIE_NAME = 'cfsub_studio_ai_status'
export const COIN_SUBSCRIPTION_STATUS_COOKIE_NAME = 'cfsub_coins_status'
export const ALL_ACCESS_NEXT_PAYMENT_DATE_COOKIE_NAME = 'cfsub_all_access_next_payment_date'
export const STUDIO_AI_NEXT_PAYMENT_DATE_COOKIE_NAME = 'cfsub_studio_ai_next_payment_date'
export const STUDIO_REFERRAL_CODE_COOKIE_NAME = 'studio_referral_code'

const PREFIXES = {
  TRIAL: 'trial',
  SUBSCRIPTION: 'subscription',
}

const STATUS = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  ON_HOLD: 'on-hold',
  PENDING: 'pending',
  LEGACY_PENDING_CANCEL: 'pending-cancel',
  PENDING_CANCEL: 'cf-pending-cancel',
  AWAITING_RENEWAL_CONFIRMATION: 'awaiting-renewal-confirmation',
  UNKNOWN: 'unknown',
}

const ACTIVE_DURATION = {
  YEARLY: 'yearly',
  MONTHLY: 'monthly',
}

export const UNDO_CANCELLATION_VALUES = {
  TRIAL_LEGACY_PENDING_CANCEL: `${PREFIXES.TRIAL}:${STATUS.LEGACY_PENDING_CANCEL}`,
  SUBSCRIPTION_LEGACY_PENDING_CANCEL: `${PREFIXES.SUBSCRIPTION}:${STATUS.LEGACY_PENDING_CANCEL}`,
  TRIAL_PENDING_CANCEL: `${PREFIXES.TRIAL}:${STATUS.PENDING_CANCEL}`,
  SUBSCRIPTION_PENDING_CANCEL: `${PREFIXES.SUBSCRIPTION}:${STATUS.PENDING_CANCEL}`,
}

const TRIAL_ACTIVE_PREFIX = `${PREFIXES.TRIAL}:${STATUS.ACTIVE}`
const SUBSCRIPTION_ACTIVE_PREFIX = `${PREFIXES.SUBSCRIPTION}:${STATUS.ACTIVE}`

const TRIAL_ACTIVE_VALUES = {
  TRIAL_ACTIVE_YEARLY: `${TRIAL_ACTIVE_PREFIX}:${ACTIVE_DURATION.YEARLY}`,
  TRIAL_ACTIVE_MONTHLY: `${TRIAL_ACTIVE_PREFIX}:${ACTIVE_DURATION.MONTHLY}`,
}

export const TRIAL_ACTIVE = {
  TRIAL_ACTIVE_YEARLY: `${TRIAL_ACTIVE_PREFIX}:${ACTIVE_DURATION.YEARLY}`,
  TRIAL_ACTIVE_MONTHLY: `${TRIAL_ACTIVE_PREFIX}:${ACTIVE_DURATION.MONTHLY}`,
  TRIAL_LEGACY_PENDING_CANCEL: `${PREFIXES.TRIAL}:${STATUS.LEGACY_PENDING_CANCEL}`,
  TRIAL_PENDING_CANCEL: `${PREFIXES.TRIAL}:${STATUS.PENDING_CANCEL}`,
}

const PAID_ACTIVE_VALUES = {
  PAID_SUBSCRIPTION_ACTIVE_YEARLY: `${SUBSCRIPTION_ACTIVE_PREFIX}:${ACTIVE_DURATION.YEARLY}`,
  PAID_SUBSCRIPTION_ACTIVE_MONTHLY: `${SUBSCRIPTION_ACTIVE_PREFIX}:${ACTIVE_DURATION.MONTHLY}`,
}

export const PAID_SUBSCRIPTION_ACTIVE = {
  PAID_SUBSCRIPTION_ACTIVE_YEARLY: `${SUBSCRIPTION_ACTIVE_PREFIX}:${ACTIVE_DURATION.YEARLY}`,
  PAID_SUBSCRIPTION_ACTIVE_MONTHLY: `${SUBSCRIPTION_ACTIVE_PREFIX}:${ACTIVE_DURATION.MONTHLY}`,
  SUBSCRIPTION_LEGACY_PENDING_CANCEL: `${PREFIXES.SUBSCRIPTION}:${STATUS.LEGACY_PENDING_CANCEL}`,
  SUBSCRIPTION_PENDING_CANCEL: `${PREFIXES.SUBSCRIPTION}:${STATUS.PENDING_CANCEL}`,
}

export const SUBSCRIPTION_STATUS_VALUES = {
  ...TRIAL_ACTIVE_VALUES,
  ...PAID_ACTIVE_VALUES,
}

export const SUBSCRIPTION_STATUS_VALUES_WITH_PENDING_CANCEL = {
  ...TRIAL_ACTIVE_VALUES,
  ...PAID_ACTIVE_VALUES,
  ...UNDO_CANCELLATION_VALUES,
}

export const AWAITING_RENEWAL_CONFIRMATION = {
  SUBSCRIPTION: `${PREFIXES.SUBSCRIPTION}:${STATUS.AWAITING_RENEWAL_CONFIRMATION}`,
  TRIAL: `${PREFIXES.TRIAL}:${STATUS.AWAITING_RENEWAL_CONFIRMATION}`,
}

export const ON_HOLD = {
  SUBSCRIPTION: `${PREFIXES.SUBSCRIPTION}:${STATUS.ON_HOLD}`,
  TRIAL: `${PREFIXES.TRIAL}:${STATUS.ON_HOLD}`,
}

export const PENDING = {
  SUBSCRIPTION: `${PREFIXES.SUBSCRIPTION}:${STATUS.PENDING}`,
  TRIAL: `${PREFIXES.TRIAL}:${STATUS.PENDING}`,
}

export const PENDING_CANCEL = {
  SUBSCRIPTION: `${PREFIXES.SUBSCRIPTION}:${STATUS.PENDING_CANCEL}`,
  TRIAL: `${PREFIXES.TRIAL}:${STATUS.PENDING_CANCEL}`,
}

export const CANCELLED = {
  SUBSCRIPTION_CANCELLED: `${PREFIXES.SUBSCRIPTION}:${STATUS.CANCELLED}`,
  TRIAL_CANCELLED: `${PREFIXES.TRIAL}:${STATUS.CANCELLED}`,
}

export const SUBSCRIPTION_STATUS_COOKIE_VALUES = {
  NO_SUBSCRIPTION: 'not_subscribed',
  UNKNOWN: 'unknown',
  ...TRIAL_ACTIVE_VALUES,
  ...PAID_ACTIVE_VALUES,
  ...UNDO_CANCELLATION_VALUES,
  ...CANCELLED,
}

export const STAGING_WORDPRESS_LOGIN_COOKIE_NAME =
  'wordpress_logged_in_5afa99022a37799b79311be4d2b5488f'
export const LIVE_WORDPRESS_LOGIN_COOKIE_NAME =
  'wordpress_logged_in_ac3575f3effc9e01556832fcfd15e097'

export const WORDPRESS_LOGIN_COOKIE_NAME = isProduction
  ? LIVE_WORDPRESS_LOGIN_COOKIE_NAME
  : STAGING_WORDPRESS_LOGIN_COOKIE_NAME

export const USER_ID_COOKIE_NAME = 'cfauth_uid'
export const USER_GQL_LOGGED_STATUS_COOKIE_NAME = 'cfauth_utp'

// Search page cookies
export const SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME =
  'search_results_include_ai_content_react'

// Banner cookies
export const UNDO_CANCELLATION_COUNTDOWN_COOKIE_NAME = 'undo_cancellation_expire'

export const GROWTHBOOK_DISABLE_ALL_FEATURES_COOKIE_NAME = 'cf-growthbook-disable'
export const GROWTHBOOK_ENABLED_FEATURES_COOKIE_NAME = 'cf-growthbook-ff'
